require('jquery-ui/ui/widget');
require('jquery-ui/ui/position');
require('jquery-ui/ui/keycode');
require('jquery-ui/ui/unique-id');
require('jquery-ui/ui/widgets/menu');
require('jquery-ui/ui/widgets/autocomplete');
require('jquery-ui/ui/widgets/datepicker');
require('jquery-timepicker/jquery.timepicker');
require('jquery-tokeninput');

const loadGoogleMapsApi = require('load-google-maps-api')

/**
 * Event editor
 */
class EventEditor {
    constructor(eventId, settings) {
        var that = this

        this.locked = false
        this.texts = {}
        this.mapLoaded = false
        this.appendDelImg = false
        this.eventId = 0
        this.tags = []
        this.guests = []
        this.guestsTokenInit = false
        this.coords = null
        this.marker = null
        this.map = null
        this.geocoder = null
        this.address_input = null
        this.autocoplete = null

        this.eventId = eventId
        this.texts = settings.texts
        this.tags = settings.tags
        this.guests = settings.guests
        this.lat = settings.lat
        this.lng = settings.lng
        this.latEvent = settings.latEvent
        this.lngEvent = settings.lngEvent
        this.appendDelImg = settings.appendDelImg
        this.initCreateEvent()

        $("#imageupload").change(function(e) {
            var files = that.getFiles(e);
            if (files.length < 1) return;
            if (files[0].size >= 4194304) {
                alert(that.texts.imageTooBig);
                $("#imageupload").closest('form').get(0).reset();
                return;
            }
            that.setImage(files[0]);
            $('input[name="existing-image"]').val(0);
            $('input[name="uploaded-image"]').val(0);
        });

        $("#image-drop-area a.delete-image").on("click", function(e){
            e.preventDefault();
            if(!window.confirm(that.texts.areYouSureDelImg)) {
                return;
            }

            $('input[name="existing-image"]').val(0);
            $('input[name="uploaded-image"]').val(0);
            $("#upimg").attr('src', '').attr('style', '');
            $("#drop-image").attr('style', '');
            $("#upimg").attr('src', 'data:image/gif;base64,R0lGODlhAQABAIAAAP///////yH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==');
            $("#imageupload").closest('form').get(0).reset();
            $("#imageupload").replaceWith($("#imageupload").clone( true ));
            $("#imageupload").val('');
            $("#image-drop-area a.delete-image").remove();

            that.appendDelImg = true;

        });

        this.initMap();
    }

    _lock() {
        this.locked = true;
    }

    _unlock() {
        this.locked = false;
    }

    setReader() {
        if (window.imageReader != undefined && window.imageReader) return;
        var that = this;

        window.imageReader = new FileReader;
        window.imageReader.onload = function (e) {
            var i = document.getElementById("upimg");
            i.src = e.target.result;
            // Temporary solution should be fixed later, temporary my ass
            $("#upimg").load(i.src, function() {
                i.onload = that.setupImage();
            });
        }
        window.imageReader.onerror = function (e) {}
    }

    setImage (file) {
        this.setReader();
        window.imageReader.readAsDataURL(file);
        $("#delete-image").val("0");
    }

    setupImage() {
        var that = this;

        if (that.appendDelImg) {
            $("#image-drop-area").append('<a class="delete-image" href="#" data-placement="right" rel="tooltip" title="' + that.texts.removeImage + '"></a>');
            $('a.delete-image').tooltip({animation: false});
            that.appendDelImg = false;
        }
    }

    getFiles(e) {
        var list = e.dataTransfer ? e.dataTransfer : (e.target ? e.target.files : false);
        //console.log('list', list);

        if (list == false || list == undefined) {
            return false;
        }
        if (list.files != undefined && list.files) {
            list = list.files;
        }

        var result = [];
        var names = {};

        for (var i = 0; i < list.length; i++) {
            var file = list[i];
            if (names[file.name]) {
                continue;
            }
            names[file.name] = true;
            if (file.size > 0) {
                result.push(file);
            }
        }

        return result;
    }

    deleteImage() {
        var that = this;

        $("#upimg").replaceWith('<img src="" id="upimg">');
        $("#imageupload").replaceWith("<input type='file' name='img' id='imageupload'>");
        $("#imageupload").change(function(e) {
            var files = that.getFiles(e);
            if (files.length < 1) return;
            that.setImage(files[0]);
        });
        $("#delete-image").val("1");
    }

    initMap() {
        var that = this;

        loadGoogleMapsApi({'key': window.googleApiPublicKey, libraries: ['places']}).then(function (googleMaps) {
            if (that.latEvent.length > 0 && that.lngEvent.length > 0)
                that.coords = new googleMaps.LatLng(that.latEvent, that.lngEvent);
            else
                that.coords = new googleMaps.LatLng(that.lat, that.lng);
            that.mapStyles = [{ featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] }];

            var mapOptions = {
                zoom: 14,
                minZoom: 6,
                maxZoom: 18,
                mapTypeId: googleMaps.MapTypeId.ROADMAP,
                center: that.coords,
                scrollwheel: true,
                panControl: false,
                zoomControl: true,
                scaleControl: false,
                mapTypeControl: false,
                overviewMapControl: false,
                rotateControl: false,
                streetViewControl: false,
                styles: that.mapStyles
            };

            that.map = new googleMaps.Map(document.getElementById("map_canvas"), mapOptions);

            that.geocoder = new googleMaps.Geocoder();
            that.address_input = $('input[name="place"]').get(0);
            that.autocomplete = new googleMaps.places.Autocomplete(that.address_input); //, { types: ['(cities)'] } , { types: ['establishment'] }
            that.autocomplete.bindTo('bounds', that.map);
            that.autocomplete.setTypes([]);
            that.infoWindow = new googleMaps.InfoWindow();
            that.infoOpened = false;
            if (that.latEvent.length > 0 && that.lngEvent.length > 0)
                that.createMarker(that.coords);

            googleMaps.event.addDomListener(that.map, 'click', function(e) {
                if(that.infoOpened) {
                    that.infoWindow.close();
                    that.infoOpened = false;
                }
                that.createMarker(e.latLng);
            });

            // Choose from autocomplete instead of submit form on ENTER key
            googleMaps.event.addDomListener(that.address_input, 'keydown', function(e) {
                if (e.keyCode == 13) {
                    if (e.preventDefault) {
                        e.preventDefault();
                    } else {
                        // Since the google event handler framework does not handleearly IE versions, we have to do it by our self. :-(
                        e.cancelBubble = true;
                        e.returnValue = false;
                    }
                }
                
                if($(that.address_input).val().length == 0){
                    $('input[name="lat"]').val('');
                    $('input[name="lng"]').val('');
                }
            });

            googleMaps.event.addDomListener(that.address_input, 'blur', function(e) {
                // clear coordinates if empty
                if($(that.address_input).val().length == 0){
                    $('input[name="lat"]').val('');
                    $('input[name="lng"]').val('');
                    if (!that.marker) that.createMarker(that.coords);
                    //that.marker.setMap(null);
                    that.removeMarker();
                }
            });


            googleMaps.event.addListener(that.autocomplete, 'place_changed', function() {
                if (!that.marker)
                    that.createMarker(that.coords);
                that.marker.setMap(that.map);
                var place = that.autocomplete.getPlace();

                //console.log("place", place);
                var r = {reference: place.reference};
                var s = new googleMaps.places.PlacesService(that.map);
                s.getDetails(r, function(res, status) {
                    //console.log('result', res, status);
                });


                if(place.geometry === undefined) return false;
                that.map.setZoom(16);
                that.map.setCenter(place.geometry.location);
                if (!that.marker)
                    that.createMarker(place.geometry.location);
                that.marker.setPosition(place.geometry.location);
                $('input[name="lat"]').val(place.geometry.location.lat());
                $('input[name="lng"]').val(place.geometry.location.lng());
                //console.log(place);

                var city = '';
                var sublocality = '';
                var country = '';
                var address = '';
                var pos = 0;
                $.each(place.address_components, function(key, value) {
                    if ($.inArray("sublocality", value.types) >= 0) {
                        sublocality = value.long_name;
                        $('input[name="sublocality"]').val(sublocality);
                    }

                    if ($.inArray("locality", value.types) >= 0) {
                        city = value.long_name;
                        $('input[name="city"]').val(city);
                    }

                    else if ($.inArray("country", value.types) >= 0) {
                        country = value.short_name;
                        $('input[name="country_code"]').val(country);
                    }
                    else if ($.inArray("route", value.types) >= 0) {
                        address = value.long_name + ' ' + address;
                        $('input[name="address"]').val(address);
                    }
                    else if ($.inArray("street_number", value.types) >= 0 && value.long_name.length > 0) {
                        address += " " + value.long_name;
                    }
                });
                if (sublocality == '') {
                    $('input[name="sublocality"]').val(sublocality);
                }
                if (city == '') {
                    $('input[name="city"]').val(city);
                }
                if (country == '') {
                    $('input[name="country_code"]').val(country);
                }
                if (address == '') $('input[name="address"]').val(address);
            });

            that.mapLoaded = true;

        }).catch(function (error) {
          console.error(error)
        })
    }

    createMarker(latLng) {
        var that = this;

        if (that.marker || that.infoOpened) return;

        that.marker = new google.maps.Marker({
            map: that.map,
            draggable: true,
            animation: google.maps.Animation.DROP,
            position: latLng
        });

        $('input[name="lat"]').val(latLng.lat());
        $('input[name="lng"]').val(latLng.lng());

        google.maps.event.addListener(that.marker, 'click', function() {
            if (that.infoOpened) {
                that.infoWindow.close();
                that.infoOpened = false;
            }
            else {
                that.infoWindow = new InfoBubble({
                    content: '<a style="display: block; font-size: 11px; font-weight: bold; padding: 2px 10px;" class="delete-marker" href="#" onclick="window.eventEditor.removeMarker(); return false;">' + that.texts.removePin + '</a>',
                    shadowStyle: 0,
                    padding: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    borderRadius: 0,
                    arrowSize: 5,
                    arrowPosition: 50,
                    borderWidth: 0,
                    disableAutoPan: true,
                    disableAnimation: true,
                    hideCloseButton: true
                });

                that.infoWindow.open(that.map, that.marker);
                that.infoOpened = true;
            }
        });

        google.maps.event.addListener(that.marker, 'dragstart', function () {
            if(that.infoOpened) {
                that.infoWindow.close();
                that.infoOpened = false;
            }
        });

        google.maps.event.addListener(that.marker, 'dragend', function () {
            $('input[name="lat"]').val(that.marker.getPosition().lat());
            $('input[name="lng"]').val(that.marker.getPosition().lng());
        });
    }

    removeMarker() {
        var that = this;

        $('input[name="lat"]').val('');
        $('input[name="lng"]').val('');

        this.infoWindow.close();
        this.marker.setMap(null);
        delete this.marker;

        setTimeout(function(){
            that.infoOpened = false;
        }, 1);
    }

    initCreateEvent() {
        var that = this;

        // drop image
        $('#drop-image').bind('dragover', function() {
            $(this).addClass('hover');
        }).bind('dragend', function() {
            $(this).removeClass('hover');
        }).bind('drop', function(e) {
            $(this).removeClass('hover');
            e.preventDefault();
        });

        var hostsAutocomplete = $('input[name="hosts-autocompete"]');
        var hostHidden = $('input[name="host"]');

        if (hostsAutocomplete.length) {
            hostsAutocomplete.bind('change', function() {
                if(!hostsAutocomplete.val().length) {
                    hostHidden.val('');
                }
            });

            new Autocomplete(hostsAutocomplete, {
                imageItems: true,
                minLength: 1,
                source: '/common/token-my-hosts/',

                callback: (data) => {
                    hostHidden.val(data.id);
                }
            });
        }

        // expand forms
        var privateCheckbox = $('input[name="private"]');

        privateCheckbox.change(function() {
            if (privateCheckbox.is(':checked')) {
                privateCheckbox.parent().addClass('checked');
            }
            else {
                privateCheckbox.parent().removeClass('checked');
            }
        });

        // Autocompletes

        $('input[name="topic"]').autocomplete({
            autoFocus: true,
            source: function( request, response ) {
                $.ajax({
                    url: "/new-event-autocomplete-topic/",
                    dataType: "json",
                    data: {
                        q: $('input[name="topic"]').val()
                    },
                    success: function( data ) {
                        response( $.map( data, function( item ) {
                            return {
                                label: item.name,
                                value: item.name,
                                id: item.id
                            }
                        }));
                    }
                });
            },
            change: function(event, ui)
            {
                if(ui.item !== null && ui.item.id !== null)
                    $('input[name="topic_id"]').val(ui.item.id);
                else
                    $('input[name="topic_id"]').val('');
            }
        });

        $('input[name="tags"]').tokenInput(
            "/new-event-autocomplete-tag/",{
                hintText: that.texts.tagsHint,
                placeholder: that.texts.tagsPlaceholder,
                preventDuplicates: true,
                tokenLimit: 10,
                onResult: function (tags) {
                    var results = [];
                    $.each(tags, function (index, value) {
                        results.push({
                            id: value.id,
                            name: value.name
                        });
                    });

                    return results;
                },
                onAdd: function (tags) {
                    $('input[name="tag_ids"]').val($('input[name="tag_ids"]').val().replace(',' + tags.id, ''));
                    $('input[name="tag_ids"]').val($('input[name="tag_ids"]').val() + ',' + tags.id);
                },
                onDelete: function(tags){
                    $('input[name="tag_ids"]').val($('input[name="tag_ids"]').val().replace(',' + tags.id, ''));
                }
            }
        );

        for (var i in this.tags) {
            $('input[name="tags"]').tokenInput("add", {
                id: this.tags[i].id,
                name: this.tags[i].name
            });
        }

        // Datepicker
        if($('input[name="start_at"]').data('date') != undefined) {
            var startDateDatepicker = $('input[name="start_at"]');
            var endDateDatepicker = $('input[name="end_at"]');

            var today = new Date();
            var now = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0);

            startDateDatepicker.datepicker({
                weekStart: 1,
                format: window.evedo.dateFormat,
                onRender: function(date) {
                    return date.valueOf() < now.valueOf() ? 'disabled' : '';
                },
                onSelect: function(e) {
                    if (endDateDatepicker.val() == '') {
                        endDateDatepicker.datepicker('setDate', new Date(e.date));
                    }
                }
            });

            if (startDateDatepicker.data("date").length > 0) {
                startDateDatepicker.datepicker('setDate', startDateDatepicker.data("date"));
            }

            endDateDatepicker.datepicker({
                weekStart: 1,
                format: window.evedo.dateFormat,
                onRender: function(date) {
                    return date.valueOf() < now.valueOf() ? 'disabled' : '';
                }
            });

            if (endDateDatepicker.data("date").length > 0) {
                endDateDatepicker.datepicker('setDate', endDateDatepicker.data("date"));
            }

            $('input[name="start_time"]').timepicker({ timeFormat: 'h:mm p',
                interval: 60,
                minTime: '10',
                maxTime: '23:00pm',
                defaultTime: '11',
                startTime: '10:00',
                dynamic: false,
                dropdown: true,
                scrollbar: true,
                showMeridian: false, defaultTime: 'value' });
            $('input[name="end_time"]').timepicker({ timeFormat: 'h:mm p',
                interval: 60,
                minTime: '10',
                maxTime: '23:00pm',
                defaultTime: '11',
                startTime: '10:00',
                dynamic: false,
                dropdown: true,
                scrollbar: true,
                showMeridian: false, defaultTime: 'value' });

        }

        if ($("#upimg").attr('src') != '') {
            $("#upimg").load($("#upimg").attr('src'), function() {
                that.setupImage();
            });
        }

        // Price
        var priceTypesRadios = $('div.how-much').find('input[name="price_type"]');
        var priceDescription = $('div.how-much').find('input[name="price_description"]');

        priceTypesRadios.bind('change', function() {
            if(priceTypesRadios.filter(':checked').val() == 2) {
                priceDescription.removeClass('hidden');
            }
            else {
                priceDescription.addClass('hidden');
            }
        });

        if(priceTypesRadios.filter(':checked').val() == 2) {
            priceDescription.removeClass('hidden');
        }
        else {
            priceDescription.addClass('hidden');
        }


        if ($('.categories').children().length){
            $('#venue_url').hide();
        }
        
        $('#venue_url').on('change', function () {
            let url = $(this).val();

            $.ajax({
                url: `${url}/seats.json`,
                dataType: "jsonp",
                success: function( data ) {
                    $('#venue_map').val(data);
                    console.log(data);
                }, error(e) {
                    console.log(e);
                }
            });
        });

        // Submit
        $('form#event-editor').submit(function() {
            if(window.ticketsEditor) {
                if(!window.ticketsEditor.checkData()) {
                    return false;
                }
            }
        });
    }

    initDatepicker(datepicker, timepicker) {
        if(datepicker.length && timepicker.length) {
            $(datepicker).datepicker({ weekStart: 1, format: window.evedo.dateFormat });
            if($(datepicker).data("date").length > 0) $(datepicker).datepicker('setDate', $(datepicker).data("date"));
            $(timepicker).timepicker({ showMeridian: false, defaultTime: 'value' });
        }
    }
}

export { EventEditor }
